/** The local analysis adapter advances 25% per one-second checkpoint. */
export function processingExperiment(parallel: number, timeoutMs: number) {
  if (
    !Number.isInteger(parallel) ||
    parallel < 1 ||
    parallel > 3 ||
    !Number.isInteger(timeoutMs) ||
    timeoutMs < 1 ||
    timeoutMs > 3600000
  )
    throw new Error('并发须为1–3，超时须为1–3600000毫秒');
  return [1, 2, 3, 4, 5, 6].map((sample, index) => {
    const elapsedMs = Math.min(
      4000,
      Math.ceil(timeoutMs / 1000) * 1000 +
        (timeoutMs % 1000 === 0 && timeoutMs < 4000 ? 1000 : 0),
    );
    return {
      sample: `固定任务 ${sample}`,
      waitMs: Math.floor(index / parallel) * elapsedMs,
      elapsedMs,
      state: timeoutMs >= 4000 ? 'succeeded' : 'failed',
      reason: timeoutMs >= 4000 ? '完成4个模拟检查点' : '超过配置超时',
    };
  });
}
